import { Link } from "react-router-dom";

export default function Services() {
  const services = [
    { name: "AI Development", link: "/services/ai" },
    { name: "Web Design", link: "/services/web" },
    { name: "Cloud & DevOps", link: "/services/cloud" },
    { name: "Custom Software", link: "/services/custom" },
    { name: "App Development", link: "/services/app" },
  ];

  return (
    <section className="min-h-screen py-16 px-4 sm:p-10 text-center bg-white">
      <h2 className="text-4xl font-bold mb-6">Our Services</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {services.map((s, i) => (
          <Link
            key={i}
            to={s.link}
            className="p-6 border rounded-lg shadow-md hover:shadow-xl hover:bg-gray-50 transition-all"
          >
            <h3 className="text-xl font-semibold">{s.name}</h3>
          </Link>
        ))}
      </div>
    </section>
  );
}
